// CSV files opened by spreadsheets (P1 export, P11 reports): UTF-8 with a byte-order mark so Arabic shows correctly,
// semicolons where the decimal mark is a comma (French), commas otherwise.
const cell = (v: unknown, sep: string): string => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return /["\r\n]/.test(s) || s.includes(sep) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function saveCsv(name: string, head: string[], lines: unknown[][], lang: string): void {
  const sep = lang === 'fr' ? ';' : ',';
  const csv = '﻿' + [head, ...lines].map((l) => l.map((v) => cell(v, sep)).join(sep)).join('\r\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
